import { connect } from 'react-redux'
import { fetchProductsByOrganizationId } from '../../state/actions/provider-products'
import { getDriversList } from '../../state/actions/drivers/'
import { fetchServiceList } from '../../state/actions/services'
import TripFilterControls from '../../components/trips/management/TripFilterControls'
import {
  actionCreators,
  getTemporaryVehicles,
  getTripsSummary,
  importTrips,
  generateRecurringTrips,
  getTemporaryVehicleTripsCount
} from '../../state/actions/trips/index'
import {
  GenerateRecurringTripsRequestDTO,
  IRiderFilters,
  IStoreState,
  ITripFilters,
  ITripSummaryFiltersDTO,
  IVehicleFilters
} from '../../types/index'
import { getMany } from '../../state/actions/riders'
import { SERVICE_LIST_TYPE } from '../../state/constants/index'
import moment, { Moment } from 'moment'

const mapStateToProps = (state: IStoreState, ownProps: any) => {
  const { tempVehicleTripsCountFetching, tempVehicleTripsCountResponse } = state.trips
  return {
    isFetching: state.trips.isFetching,
    orgId: state.organizations.currentOrgId,
    productIds: state.providerProduct.currentProductIds,
    currentOrg: state.organizations.items[state.organizations.currentOrgId || ''],
    filters: state.trips.filters,
    summaryFilters: state.trips.summaryFilters,
    importResults: state.trips.importResults,
    products: Object.values(state.providerProduct.items),
    drivers: Object.values(state.drivers.items),
    riders: { items: Object.values(state.riders.items), total: state.riders.metadata.total || 0 },
    services: { items: Object.values(state.service.items), total: state.service.metadata.total || 0 },
    temporaryVehicles: state.trips.temporaryVehicleResponse ? Object.values(state.trips.temporaryVehicleResponse) : [],
    tempVehicleTripsCountFetching,
    totalTrips: tempVehicleTripsCountResponse ? tempVehicleTripsCountResponse.totalTrips : []
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    getTripsSummaryRequest: () => dispatch(actionCreators.getTripsSummaryRequest()),
    updateTripFilters: (params: ITripFilters) => dispatch(actionCreators.updateTripFilters(params)),
    updateTripSummaryFilters: (params: ITripSummaryFiltersDTO) =>
      dispatch(actionCreators.updateTripSummaryFilters(params)),
    importTrips: (orgId: string, awsData: { Location: string; Key: string; Bucket: string }) =>
      dispatch(importTrips(orgId, awsData)),
    getRiders: (filters: IRiderFilters) => dispatch(getMany(filters)),
    onComponentMount: (organizationId: string, type: string) => {
      dispatch(
        fetchProductsByOrganizationId({
          organizationId,
          skip: 0,
          take: 9999, // get all existing products
          active: type === 'active',
          orderBy: 'providers_products.name',
          sort: 'ASC'
        })
      )
      dispatch(getDriversList({ skip: 0, take: 9999, organizationId, sortBy: ['name-asc'] }))
      dispatch(fetchServiceList(type, organizationId, 'services.name', 'ASC'))
      dispatch(getMany({ skip: 0, take: 100, orgId: organizationId, sortBy: ['name-asc'] }))
      dispatch(getTemporaryVehicles())
    },
    generateRecurringTrips: (params: GenerateRecurringTripsRequestDTO) => dispatch(generateRecurringTrips(params)),
    getTemporaryVehicleTripsCount: (serviceId: string) => dispatch(getTemporaryVehicleTripsCount(serviceId))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TripFilterControls)

export const dateRangeTripsManagement = [
  {
    label: 'start',
    value: moment()
      .startOf('day')
      .format('MM/DD/YYYY hh:mmA')
      .toString()
  },
  {
    label: 'end',
    value: moment()
      .endOf('day')
      .format('MM/DD/YYYY hh:mmA')
      .toString()
  }
]

export function updateStartDate(startDate: string | Moment) {
  dateRangeTripsManagement[0].value = moment(startDate, 'MM/DD/YYYY hh:mmA')
    .format('MM/DD/YYYY hh:mmA')
    .toString()
}

export function updateEndDate(endDate: string | Moment) {
  dateRangeTripsManagement[1].value = moment(endDate, 'MM/DD/YYYY hh:mmA')
    .format('MM/DD/YYYY hh:mmA')
    .toString()
}



// WEBPACK FOOTER //
// ./src/containers/trips/TripFilterControls.ts